"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightListItem = exports.InsightListItemCore = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var util_1 = require("@gooddata/util");
var InsightListItemDate_1 = require("./InsightListItemDate");
var Button_1 = require("../Button");
var ShortenedText_1 = require("../ShortenedText");
var DescriptionPanel_1 = require("../DescriptionPanel");
var VISUALIZATION_TYPE_UNKNOWN = "unknown";
var WIDGET_TYPE_KPI = "kpi";
var visualizationIconWidthAndPadding = 42;
var tooltipAlignPoints = [
    {
        align: "cr cl",
    },
    {
        align: "cl cr",
        offset: {
            x: -visualizationIconWidthAndPadding,
            y: 0,
        },
    },
];
var modifiedArrowOffsets = tslib_1.__assign(tslib_1.__assign({}, DescriptionPanel_1.DESCRIPTION_PANEL_ARROW_OFFSETS), { "cr cl": [30, 0] });
/**
 * @internal
 */
var InsightListItemCore = /** @class */ (function (_super) {
    tslib_1.__extends(InsightListItemCore, _super);
    function InsightListItemCore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shortenedTextRef = react_1.createRef();
        _this.handleClickDelete = function (e) {
            e.stopPropagation();
            var onDelete = _this.props.onDelete;
            if (onDelete) {
                _this.props.onDelete();
            }
        };
        _this.renderLock = function () {
            if (_this.props.isLocked) {
                return react_1.default.createElement("i", { className: "gd-icon-lock" });
            }
            return false;
        };
        _this.renderUpdatedDateTime = function (date) {
            var type = _this.props.type;
            if (!date) {
                return false;
            }
            if (type === WIDGET_TYPE_KPI) {
                return react_1.default.createElement("span", null);
            }
            return react_1.default.createElement(InsightListItemDate_1.InsightListItemDate, { config: InsightListItemDate_1.getDateTimeConfig(date) });
        };
        _this.shouldRenderActions = function () { return !!_this.props.onDelete; };
        _this.renderActions = function () {
            return (_this.shouldRenderActions() && (react_1.default.createElement("div", { className: "gd-visualizations-list-item-actions" },
                react_1.default.createElement(Button_1.Button, { className: "gd-button-link gd-button-icon-only gd-button-small\n                        gd-icon-trash gd-visualizations-list-item-action-delete s-delete-item", onClick: _this.handleClickDelete }))));
        };
        return _this;
    }
    InsightListItemCore.prototype.render = function () {
        var _a = this.props, title = _a.title, description = _a.description, updated = _a.updated, _b = _a.type, type = _b === void 0 ? VISUALIZATION_TYPE_UNKNOWN : _b, isSelected = _a.isSelected, isLoading = _a.isLoading, onClick = _a.onClick, onDescriptionPanelOpen = _a.onDescriptionPanelOpen, _c = _a.showDescriptionPanel, showDescriptionPanel = _c === void 0 ? false : _c;
        var iconClassName = classnames_1.default("gd-vis-type", "gd-vis-type-" + type);
        var visualizationListItemClassname = classnames_1.default("gd-visualizations-list-item", "s-" + util_1.stringUtils.simplifyText(title), {
            "is-selected": isSelected,
        });
        return (react_1.default.createElement("div", { className: visualizationListItemClassname, onClick: onClick },
            this.renderActions(),
            showDescriptionPanel ? (react_1.default.createElement("div", { className: "gd-visualizations-list-item-description" },
                react_1.default.createElement(DescriptionPanel_1.DescriptionPanel, { onBubbleOpen: onDescriptionPanelOpen, title: title, description: description, arrowOffsets: this.shouldRenderActions() ? modifiedArrowOffsets : undefined }))) : null,
            react_1.default.createElement("div", { className: "gd-visualizations-list-item-content" },
                react_1.default.createElement("div", { className: "gd-visualizations-list-item-content-name" },
                    this.renderLock(),
                    react_1.default.createElement(ShortenedText_1.ShortenedText, { ref: this.shortenedTextRef, tooltipAlignPoints: tooltipAlignPoints, displayTooltip: !showDescriptionPanel }, isLoading
                        ? this.props.intl.formatMessage({ id: "gs.visualizationsList.loading" })
                        : title)),
                react_1.default.createElement("div", { className: "gd-visualizations-list-item-content-date" }, this.renderUpdatedDateTime(updated))),
            react_1.default.createElement("div", { className: "gd-vis-type-container" },
                react_1.default.createElement("div", { className: iconClassName }))));
    };
    InsightListItemCore.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.width !== this.props.width && this.shortenedTextRef.current) {
            this.shortenedTextRef.current.recomputeShortening();
        }
    };
    return InsightListItemCore;
}(react_1.Component));
exports.InsightListItemCore = InsightListItemCore;
/**
 * @internal
 */
exports.InsightListItem = react_intl_1.injectIntl(InsightListItemCore);
//# sourceMappingURL=InsightListItem.js.map